// extracted by mini-css-extract-plugin
export default {"servicesSection":"Services_servicesSection__s1CVq","ServicesWrapper":"Services_ServicesWrapper__z4n31","cardsContainer":"Services_cardsContainer__0E0TK"};